// Thin helper that triggers navigation via the global hash. The app root
// uses HashRouter, so updating window.location.hash is enough to drive
// navigation from imperative contexts (e.g. the command palette).
export function navigate(path: string) {
  if (window.location.hash !== `#${path}`) {
    window.location.hash = path;
  }
}